// extracted by mini-css-extract-plugin
export default {"container":"style_container__3QaOc","cardChild":"style_cardChild__ZLv7l","formStyle":"style_formStyle__lJiE+","footer":"style_footer__B1c8g"};